__turbopack_context__.v({
  "simpleInput": "SimpleSearch-module-scss-module__EloqJW__simpleInput",
});
